import { BaseModel } from './base.model';

export class BaseApiResponseModel extends BaseModel {
    message: string;
}
